export enum LyftConstants {
  LYFT_HOST = 'https://www.lyft.com',
  LYFT_CLIENT_ID = 'kQvH8nMeCE-d',
  LYFT_RIDE_LINK = 'https://ride.lyft.com/profile/rides?tab=All',
}
